import { MeetOurDoctorsPage } from "~/components/meet-our-doctors/MeetOurDoctorsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/meet-our-doctors")({
  head: async () =>
    (await import("~/utils/liveSeoHead")).headFromLiveSeo("/meet-our-doctors"),
  component: MeetOurDoctorsPage,
});
